'use client';

import { c as _c } from "react/compiler-runtime";
import { useWebView } from '../../hooks';
import { AdyenDataCollectionScript, AfterPayScript, MedalliaScript, UsableNetScript } from '../../scripts';
export function BodyStartScripts() {
  const $ = _c(7);
  const isWebView = useWebView();
  let t0;
  if ($[0] !== isWebView) {
    t0 = !isWebView && <MedalliaScript />;
    $[0] = isWebView;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  let t2;
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <AdyenDataCollectionScript />;
    t2 = <AfterPayScript />;
    t3 = <UsableNetScript />;
    $[2] = t1;
    $[3] = t2;
    $[4] = t3;
  } else {
    t1 = $[2];
    t2 = $[3];
    t3 = $[4];
  }
  let t4;
  if ($[5] !== t0) {
    t4 = <>{t0}{t1}{t2}{t3}</>;
    $[5] = t0;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  return t4;
}